// wraps our Layout component in order to allow adjacent JSX elements
const aux = (props) => props.children;

export default aux;


// WEBPACK FOOTER //
// ./src/hoc/auxilary.js